<template>
  <el-row :gutter="20" style="margin: 30px 0;">
    <el-col :span="12" :offset="6">
      <el-steps style="max-width: 100%" :active="active" finish-status="success" :align-center="true" class="mb-4">
        <el-step title="导入数据" />
        <el-step title="调整导出图片" />
       
      </el-steps>
    </el-col>

    <el-col :span="20" v-show="active === 0" :offset="2" style="margin-top: 30px;">
      <el-input
        v-model="exceldata"
        style="width: 100%"
        :autosize="{ minRows: 10, maxRows: 16 }"
        type="textarea"
        placeholder="请黏贴表格内容，必须包含表头，方便程序识别字段"
      />
      <el-text class="mx-1" type="primary" style="margin-top: 20px;">先整理数据后再点击下一步。</el-text>
      <el-button-group style="width: 100%; display: flex; justify-content: center; margin-top: 12px">
        <el-button @click="excelclear">清空</el-button>
        <el-button @click="Organize">整理数据</el-button>
        <el-button @click="next" v-show="exceldataok == 1">下一步</el-button>
      </el-button-group>
    </el-col>

    <el-col :span="22" v-show="active === 1" :offset="1" style="margin-top: 30px;">
      <div class="img-container">
        <div ref="exportContainer" class="imgexportbox">
            <el-image style="width: 100%; height: 100%" :src="nowimgurl" fit="fill"></el-image>
            <div class="imgdatatext" v-if="Datalength> 0">
              <p v-for="(item,index) in DataList[DataIndex-1]" :key="index" :style="item['style']" >
                  <canvas ref="barcodeCanvas" :data-text="item.text" :data-dw="item.position.left" :data-dh="item.position.top" v-if="item.type=='2'" :style="item.position.style"></canvas>               
                <span v-if="item.type=='1'"> {{ item.text }}</span>               
              </p>
            </div>
        </div>
        <div class="imgdatabox">
          <el-form ref="form"  label-width="200px" style="width: 100%;">
                <el-form-item label="选择吊牌模板">
                  <el-select v-model="modelIndex" placeholder="">
                    <el-option v-for="(item,index) in modelList" :key="index" :label="item.name" :value="index">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="选择数据">
                  <el-pagination background layout="prev, pager, next" :page-size="1" :total="Datalength" @current-change="DataIndex" @update:current-page="changeimg"/>
                </el-form-item>
                <el-form-item v-for="(item,index) in DataList[DataIndex-1]" :key="index" :label="item.dataindex + (item.type === 2 ? ' (用于生成条码图)' : '')">
                  <el-input v-model="item.text" placeholder="请输入内容" style="width: 100%;" v-if="item.type === 1"></el-input>
                  <el-input v-model="item.text" placeholder="请输入内容" style="width: 100%;" v-if="item.type === 2" @change="generateBarcodes()"></el-input>
                </el-form-item>
          </el-form>
          <el-button-group style="width: 100%; display: flex; justify-content: center; margin-top: 12px">  
            <el-button @click="prev" >返回</el-button>
            <el-button @click="exportToImage">导出为图片</el-button>
          </el-button-group> 
        </div> 
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import tagimgData from '@/assets/data.json';
import JsBarcode from 'jsbarcode';
import { ref, onMounted, nextTick,watch } from 'vue';
import html2canvas from 'html2canvas';
import 'element-plus/theme-chalk/display.css';
import { ElNotification } from 'element-plus';

const imgname = ref('exported-image.png'); // 设置默认图片名称
const exceldata = ref('');
const exportContainer = ref(null);
const exceldataok = ref(0);
const active = ref(0);
const dataok = ref([]);
const modelList = ref(tagimgData) // 读取模板数据
const modelIndex = ref(0) // 默认选择第一个模板
const nowimgurl = ref('');
const modelData = ref(modelList.value[modelIndex.value].datalist)
const DataList = ref([])
const Datalength = ref(0)
const DataIndex = ref(1)

const barcodeCanvas = ref(null);

onMounted(() => {
  try {
    // 动态引入图片
    nowimgurl.value = require(`@/assets/${modelList.value[modelIndex.value].imgurl}`);
  } catch (error) {
    console.error('图片加载失败:', error);
  }
});
watch(modelIndex, (newIndex) => {
  modelData.value = modelList.value[newIndex].datalist;
  Organize(); // 重新组织数据
  nowimgurl.value = require(`@/assets/${modelList.value[modelIndex.value].imgurl}`);
});

const next = () => {
  if (active.value < 1) {
    active.value++;
  }

};

const prev = () => {
 
    active.value--;
  
};

const excelclear = () => {
  exceldata.value = '';
  exceldataok.value = 0;
}

const changeimg = (index) => {
  DataIndex.value = index
  generateBarcodes();
}

const generateBarcodes = async () => {
  await nextTick();
  const canvasElements = barcodeCanvas.value;
  if (canvasElements) {
    canvasElements.forEach((canvas, index) => {
      if (canvas) {
        
        const dataItem = canvas.dataset.text;
        const dw = canvas.dataset.dw;
        const dh = canvas.dataset.dh;
       
        JsBarcode(canvas, dataItem, {
          format: 'CODE128',
          width: dw,
          height: dh,
          displayValue: false
        });
      } else {
        console.error('Barcode canvas element not found at index:', index);
      }
    });
  }
};

/**
 * 组织Excel数据函数
 * 该函数用于将字符串形式的Excel数据转换为对象数组形式
 * 主要处理步骤包括：提取表头、解析数据行、将数据行与表头匹配生成对象、最后汇总到结果数组中
 */
const Organize = () => {
  // 将Excel数据按行分割成数组，去除首尾空行
  const lines = exceldata.value.trim().split('\n');
  // 获取表头
  const headers = lines[0].split('\t');
  const headerCount = headers.length;
  // 跳过表头行，获取数据行
  const dataLines = lines.slice(1);
  const result = [];
  let currentLine = '';

  // 遍历数据行，构造结果数组
  dataLines.forEach((line) => {
    if (currentLine) {
      currentLine += '\n' + line;
    } else {
      currentLine = line;
    }

    // 按照制表符分割当前行，检查是否形成一个完整的数据项
    const values = currentLine.split('\t');
    if (values.length === headerCount) {
      // 创建一个空对象，用于存储当前数据项
      const item = {};
      // 遍历表头，将数据项与表头匹配，填充到对象中
      headers.forEach((header, index) => {
        item[header] = values[index].trim();
      });
      // 将构造好的数据项添加到结果数组中
      result.push(item);
      // 重置当前行，准备处理下一行数据
      currentLine = '';
    }
  });

  exceldataok.value = 1; // 确保 exceldataok 的值被正确更新
  dataok.value = result;
 
  let dplist = []
  dataok.value.forEach((item) => {
    let dps = []

    modelData.value.forEach((item2) => {
      // 检查 item[item2.dataindex] 是否为 undefined
      const text = item[item2.dataindex] !== undefined ? item[item2.dataindex].replace(/"|"/g, '') : '';
      dps.push({
        "type": item2.type,
        "dataindex": item2.dataindex,
        "position": item2.position,
        "text": text, // 使用检查后的 text
        "style": item2.style
      })    
   
    })
  
    dplist.push(dps)
  })
  DataList.value = dplist
  Datalength.value = DataList.value.length


  generateBarcodes(); // 调用生成条形码的函数

  ElNotification({
    title: 'OK',
    message: '数据整理完成',
    type: 'success',
  });

};

const exportToImage = async () => {
  if (exportContainer.value) {
    try {
      // 使用 html2canvas 将容器转换为画布
      const canvas = await html2canvas(exportContainer.value);
      // 将画布内容转换为图片的 data URL
      const dataURL = canvas.toDataURL('image/png');
      // 创建一个 <a> 元素用于下载图片
      const link = document.createElement('a');
      link.href = dataURL;
      let datas= DataList.value[DataIndex.value-1]
      let savename = ''
      datas.forEach((item) => {
        if (item.dataindex === '编号' || item.dataindex === '款号') {
          savename = item.text
        }
      })
 
      link.download =savename ? savename : imgname.value
      // 模拟点击下载链接
      link.click();
    } catch (error) {
      console.error('导出图片时出错:', error);
    }
  }
};
</script>

<style scoped>
.export-container {
  padding: 20px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
.img-container{    width: 100%;
    display: flex
;
    justify-content: space-between;
    align-items: flex-start;
  }
.img-container .imgexportbox{width: 750px;height: 1600px;box-shadow: 0 0 10px #ccc;min-width: 750px;position: relative;}
.img-container .imgdatabox{    flex: 1;
    margin-left: 30px;
    display: flex
;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;    max-height: 84vh;
    overflow-y: auto;position: sticky;
    top: 0;}
    .imgdatatext{position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    font-family: 宋体;
    color: #000;}
    .imgdatatext p{margin: 0;position: absolute;line-height: 1.1;
    }
    .imgdatatext p canvas{width: 475px;height: 125px;}
</style>